/* eslint-disable @typescript-eslint/prefer-for-of */
import { isString } from '@slardar/sdk-template';
import { getDefaultDocument } from './defaults';
export var getCookieId = function (cookieIdName) {
    var document = getDefaultDocument();
    try {
        if (document === null || document === void 0 ? void 0 : document.cookie) {
            return getValueFromCookieName(document.cookie, cookieIdName);
        }
    }
    catch (_e) {
        // do nothing
    }
    return '';
};
export var setCookie = function (key, value) {
    var document = getDefaultDocument();
    if (document && key) {
        try {
            document.cookie = key + "=" + value + ";max-age=" + 90 * 24 * 60 * 60;
        }
        catch (_e) {
            // do nothing
        }
    }
};
export function getValueFromCookieName(cookie, name) {
    if (!cookie || !name) {
        return '';
    }
    return parseCookie(cookie)[name] || '';
}
function parseCookie(cookie) {
    var list = cookie.split(';');
    var cookieObj = {};
    for (var i = 0; i < list.length; i++) {
        var pair = list[i].split('=');
        var cookieKey = isString(pair[0]) && pair[0].trim();
        if (cookieKey && isString(pair[1])) {
            cookieObj[cookieKey] = pair[1].trim();
        }
    }
    return cookieObj;
}
//# sourceMappingURL=cookie.js.map